
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/covid-statement",
      function () {
        return require("private-next-pages/covid-statement.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/covid-statement"])
      });
    }
  